'use client';

import { t } from '@repo/i18n';
import { useLocale } from '@repo/i18n/react';

import { Eye, EyeOff } from 'lucide-react';
import * as React from 'react';

import { cn } from '../../lib/utils';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

const PasswordInput = React.forwardRef<
  HTMLInputElement,
  Omit<React.ComponentProps<'input'>, 'type'>
>(({ className, ...props }, ref) => {
  useLocale();

  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <div className="relative">
      <Button
        aria-label={showPassword ? t('ui.maskPassword') : t('ui.revealPassword')}
        className="absolute start-0 top-0 flex h-full items-center justify-center pe-3"
        onClick={() => setShowPassword((show) => !show)}
        type="button"
        variant="link"
      >
        {showPassword ? (
          <EyeOff aria-hidden className="h-5 w-5 text-muted-foreground" />
        ) : (
          <Eye aria-hidden className="h-5 w-5 text-muted-foreground" />
        )}
      </Button>
      <Input
        className={cn('ps-10', className)}
        ref={ref}
        type={showPassword ? 'text' : 'password'}
        {...props}
      />
    </div>
  );
});

PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
